import { CoreHTTPBaseRepository } from "src/contexts/_shared/infrastructure/core/CoreHTTPBaseRepository";
import { AuthRepository, GetTokenParams, SendTwoFactorParams } from "../domain/AuthRepository";

export class HTTPAuthRepository extends CoreHTTPBaseRepository implements AuthRepository {
  public sendTwoFactor = async ({
    email,
    linkType,
    linkId,
    slug,
    loginType,
  }: SendTwoFactorParams) => {
    const params: { [key: string]: string } = { linkType, slug };

    if (linkId) {
      params.linkId = linkId;
    }

    await this.request<{}>({
      method: "POST",
      url: `/internal/documentation-area/auth0/send-two-factor`,
      data: {
        email,
        loginType,
      },
      params,
    });
    return;
  };

  public getToken = async ({ code, email, linkType, linkId }: GetTokenParams) => {
    const params: { [key: string]: string } = { linkType };

    if (linkId) {
      params.linkId = linkId;
    }

    const response = await this.request<{
      access_token: string;
    }>({
      method: "POST",
      url: `/internal/documentation-area/auth0/token`,
      data: {
        otp: code,
        email,
      },
      params,
    });

    const { access_token } = response;
    return access_token;
  };
}
